export const NumberedArguments = ({ items }) => (
  <div className="numbered-args">
    {items.map((item, idx) => (
      <div className="numbered-arg" key={item.title}>
        <div className="numbered-arg-num">{String(idx + 1).padStart(2, "0")}</div>
        <div>
          <h3>{item.title}</h3>
          {item.body.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </div>
      </div>
    ))}
  </div>
);
